'use client';

import { useState, useEffect } from 'react';

const useTimedOpen = (duration: number = 4000) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let timer: any;

    if (isOpen) {
      timer = setTimeout(() => {
        setIsOpen(false);
      }, duration);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [isOpen, duration]);

  return [isOpen, open, close] as const;
};

export default useTimedOpen;
